import { localStorageInstance } from '@gem/modules/storage';
import { parseJSON } from '@gem/utils';

import { ProjectInstallationType } from 'CONFIG_TYPES';

export interface IAuthorizationConfig {
  email: string;
  baseUrl: string;
  alias: string;
  type: ProjectInstallationType;
}

const AUTHORIZATION_CONFIG_STORAGE_KEY = 'authorization-config';

export function set(config: IAuthorizationConfig): void {
  try {
    const configString = JSON.stringify(config) || '';
    localStorageInstance.setItem(AUTHORIZATION_CONFIG_STORAGE_KEY, configString);
  } catch {
    localStorageInstance.setItem(AUTHORIZATION_CONFIG_STORAGE_KEY, '');
  }
}

export function get(): IAuthorizationConfig | null {
  const data = localStorageInstance.getItem(AUTHORIZATION_CONFIG_STORAGE_KEY);
  if (!data) {
    return null;
  }

  const config = parseJSON<IAuthorizationConfig>(data) || null;
  return config;
}

export function remove(): void {
  localStorageInstance.removeItem(AUTHORIZATION_CONFIG_STORAGE_KEY);
}
